import { ScheduleState } from "../../../type/schedule-state";

export const clearDateToWorkDispatch = (state: ScheduleState) => {
  state.dateToWork = "";
};
